import React, { FC } from "react";

import { AddCircle, HighlightOff, InfoOutlined } from "@mui/icons-material";
import { CircularProgress, Grid, IconButton } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton/IconButton";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";

export interface IgIconButtonProps extends IconButtonProps {
  loading?: boolean;
  iconType?: "add" | "clear";
  buttonLabel?: string;
  tooltip?: string;
}

export const IgIconButton: FC<IgIconButtonProps> = (props) => {
  const {
    children,
    onClick,
    loading,
    iconType,
    buttonLabel,
    tooltip,
    sx,
    ...rest
  } = props;

  const IconButtonChild = loading ? (
    <CircularProgress size={23} />
  ) : iconType && iconType === "add" ? (
    <AddCircle color={"primary"} />
  ) : iconType && iconType === "clear" ? (
    <HighlightOff color={"disabled"} />
  ) : (
    children
  );

  if (buttonLabel) {
    return (
      <Grid item container direction={"row"} alignItems={"center"}>
        <Grid item>
          <IconButton
            {...rest}
            onClick={Boolean(loading) && Boolean(onClick) ? undefined : onClick}
          >
            {IconButtonChild}
          </IconButton>
        </Grid>
        <Grid item>
          <IgTypography sx={{ fontSize: "14px" }}>{buttonLabel}</IgTypography>
        </Grid>
        {tooltip ? (
          <IgTooltip title={tooltip}>
            <IconButton aria-label="info" size={"small"}>
              <InfoOutlined fontSize={"small"} />
            </IconButton>
          </IgTooltip>
        ) : null}
      </Grid>
    );
  } else {
    return (
      <IconButton
        {...rest}
        onClick={Boolean(loading) && Boolean(onClick) ? undefined : onClick}
      >
        {IconButtonChild}
      </IconButton>
    );
  }
};
